// Ensure HTTPS and log the URL configuration
const getBackendUrl = () => {
  const url = process.env.REACT_APP_BACKEND_URL || 'https://assess-lmf-back.hippolyte.ai';
  const secureUrl = url.replace(/^http:/, 'https:');
  console.log('%c[DEBUG] API Configuration', 'background: #222; color: #bada55');
  console.log('Original URL:', url);
  console.log('Secure URL:', secureUrl);
  return secureUrl;
};

const API_BASE_URL = getBackendUrl();

export const api = {
  async post(endpoint, data, headers = {}) {
    try {
      const finalEndpoint = endpoint.endsWith('/') ? endpoint : `${endpoint}/`;
      const fullUrl = `${API_BASE_URL}${finalEndpoint}`;
      //const fullUrl = `${API_BASE_URL}${endpoint}`;

      console.log('[DEBUG API] API_BASE_URL:', API_BASE_URL);
      console.log('[DEBUG API] Endpoint:', endpoint);
      console.log('[DEBUG API] Full URL:', fullUrl);
      console.log('[DEBUG API] Protocol:', new URL(fullUrl).protocol);

      // Configuration des headers
      const requestHeaders = {
        Accept: 'application/json',
        ...(data instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        ...headers,
      };

      console.log('[DEBUG] Request headers:', requestHeaders);

      const fetchOptions = {
        method: 'POST',
        headers: requestHeaders,
        credentials: 'include',
        mode: 'cors',
        body: data instanceof FormData ? data : JSON.stringify(data),
        redirect: 'follow', // Suivre les redirections automatiquement
      };

      const response = await fetch(fullUrl, fetchOptions);

      // Gérer la redirection 307 manuellement si nécessaire
      if (response.status === 307) {
        const redirectUrl = response.headers.get('Location');
        console.log('[DEBUG API] Redirection vers:', redirectUrl);
        
        // Faire une nouvelle requête vers l'URL de redirection
        const redirectResponse = await fetch(redirectUrl, {
          ...fetchOptions,
          headers: {
            ...requestHeaders,
            'Origin': new URL(API_BASE_URL).origin
          }
        });

        if (!redirectResponse.ok) {
          const errorData = await redirectResponse.text();
          console.error('[DEBUG API] Erreur après redirection:', {
            status: redirectResponse.status,
            headers: Object.fromEntries(redirectResponse.headers.entries()),
            body: errorData
          });
          throw new Error(`HTTP error! status: ${redirectResponse.status}, message: ${errorData}`);
        }

        return await redirectResponse.json();
      }

      if (!response.ok) {
        const errorData = await response.text();
        console.error('[DEBUG API] Erreur de requête:', {
          status: response.status,
          headers: Object.fromEntries(response.headers.entries()),
          body: errorData
        });
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData}`);
      }

      return await response.json();
    } catch (error) {
      console.error('[DEBUG API] Erreur:', error);
      throw error;
    }
  },

  async get(endpoint) {
    try {
      const finalEndpoint = endpoint.endsWith('/') ? endpoint : `${endpoint}/`;
      const fullUrl = `${API_BASE_URL}${finalEndpoint}`;
      
      console.log('[DEBUG API] Making GET request to:', fullUrl);

      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        mode: 'cors',
        redirect: 'follow',
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.error('[DEBUG API] Erreur de requête GET:', {
          status: response.status,
          headers: Object.fromEntries(response.headers.entries()),
          body: errorData
        });
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData}`);
      }

      return await response.json();
    } catch (error) {
      console.error('[DEBUG API] Erreur GET:', error);
      throw error;
    }
  },
};
